/**
 * Date utility functions for date-only handling
 * These functions treat dates as calendar dates without timezone conversion
 *
 * The backend returns dates as "YYYY-MM-DD" strings (no time/timezone).
 * These utilities ensure "December 21" displays as December 21 everywhere.
 */

/**
 * Parse a "YYYY-MM-DD" string as a LOCAL date (not UTC)
 * This ensures "2025-12-21" displays as Dec 21 in any timezone
 */
export function parseLocalDate(dateStr: string): Date {
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day, 0, 0, 0, 0);
}

/**
 * Get today's date as "YYYY-MM-DD" string in user's local timezone
 */
export function getTodayString(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * Calculate days between two date strings
 * Positive = toDate is in future, Negative = toDate is in past
 */
export function daysBetween(fromDateStr: string, toDateStr: string): number {
  const from = parseLocalDate(fromDateStr);
  const to = parseLocalDate(toDateStr);
  const diffMs = to.getTime() - from.getTime();
  return Math.round(diffMs / (1000 * 60 * 60 * 24));
}
